import styled from "styled-components"

const Container = styled.div`
  min-width: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: ${props => (props.noTop ? 0 : "100px")};
  padding-left: 25%;
  padding-right: 25%;
  background-color: ${props => (props.dark ? "#242536" : "white")};
`

export default Container
